import React from 'react'
import styled from 'styled-components'

import { color, bp } from '../globalStyles'

const SectionTitleWrap = styled.div`
  background: white;
  padding: 1.5rem 2rem;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.04), 0 0 2px 0 rgba(0, 0, 0, 0.04),
    0 0 2px 0 rgba(0, 0, 0, 0.18);

  @media (${bp.desktop}) {
    box-shadow: none;
    padding: 1.5rem;
    text-align: center;
    border-bottom: 1px solid ${color.midGrey};
  }
`
const Title = styled.h3`
  margin-bottom: 0;
`
const Subtitle = styled.div`
  margin-bottom: 0;
  font-size: 1.4rem;
  font-weight: 400;
  color: ${color.darkGrey};
`

const SectionTitle = ({ title, subtitle }) => (
  <SectionTitleWrap>
    {title && <Title>{title}</Title>}
    {subtitle && <Subtitle>{subtitle}</Subtitle>}
  </SectionTitleWrap>
)

export default SectionTitle



// WEBPACK FOOTER //
// ./src/components/SectionTitle.js